import { create } from "zustand";
import { SelectedVehicle } from "../shared/models/SelectedVehicle";

const InitialState = {name: '', chassis: '', itSpeed: 0, itBraking: 0, itCoasting: 0, itKickdown: 0, 
  itAcceleration: 0, itRpm: 0, itClutch: 0, itOperationalInsistence: 0, itIdling: 0, itIdlingAc: 0, 
  itAttentiveDriving: 0, itRollover: 0, itGoodPractices: 0}

interface SelectVehicleState {
  selectedVehicle: SelectedVehicle;
  setSelectedVehicle: (vehicle: SelectedVehicle) => void;
  clearSelectedVehicle: () => void;
}

export const useSelectVehicleStore = create<SelectVehicleState>((set) => ({
  selectedVehicle: InitialState,
  clearSelectedVehicle: () => set((state) => ({
    selectedVehicle: InitialState
  })),
  setSelectedVehicle: (vehicle) => set((state) => ({
    selectedVehicle: vehicle
  })),
}));